import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  createTheme,
  ThemeProvider,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import { get, post } from "../../utility/fetchWeb";
import notification from "../../utility/notification";
import { formatDate, formatTime } from "../../utility/general";
import BankPaymentModal from "../Layout/BankPaymentModal";
import PaymentModal from "../Layout/PaymentModal";
import PaymentConfirmationModal from "../Layout/PaymentConfirmationModal";
import DoctorRatingForm from "../Layout/DoctorRatingForm";
import ScheduleViewer from "../ScheduleViewer";

// Generate next 15 days from today
const days = Array.from({ length: 15 }, (_, i) => {
  const date = new Date();
  date.setDate(date.getDate() + i);
  return {
    day: date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase(),
    date: date.getDate(),
    fullDate: date.toDateString(),
  };
});

const times = [
  "09:00 AM",
  "09:30 AM",
  "10:00 AM",
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "03:00 PM",
  "04:00 PM",
];

const theme = createTheme({
  palette: {
    primary: {
      main: "#4CAF50", // green theme
    },
  },
});


function useQuery() {
  return new URLSearchParams(useLocation().search);
}


export default function BookAppointment() {
  const [selectedDate, setSelectedDate] = useState(days[0].fullDate); // Default to today
  const [selectedTime, setSelectedTime] = useState("12:00 PM");
  const [fullName, setFullName] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [problem, setProblem] = useState("");
  const [data, setData] = useState({});
  const [open, setOpen] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [paymentMethod, setPaymentMethod] = React.useState('card');
  const [paymentStatus, setPaymentStatus] = React.useState('pending');
  const [openConfirmationModal, setOpenConfirmationModal] = React.useState(false);
  const [ratingOpen, setRatingOpen] = React.useState(false);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [bookingPayload, setBookingPayload] = useState(null);

  const handleCloseConfirmation = () => {
    setOpenConfirmationModal(false);
  };

  const handleRatingOpen = () => {
    setRatingOpen(false);
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleOpenBankModal = () => {
    setModalOpen(true);
  };

  const handleNext = () => {
    setOpen(true);
  }


  const query = useQuery();

  console.log('Query:', query);

  const getData = async () => {
    try {
      if (query?.get("cat") === 'doctor') {
        const response = await get(`/doctors/doctors/${query?.get("id")}`);
        console.log('Response:', response);
        setData(response);
      } else if (query?.get("cat") === 'hospital') {
        const response = await get(`/hospitals/list`);
        console.log('Response:', response);
        setData(response);
      }
      else if (query?.get("cat") === 'lab') {
        const response = await get(`/lab/list`);
        console.log('Response:', response);
        setData(response);
      }
      else if (query?.get("cat") === 'pharmacy') {
        const response = await get(`/pharmacy/list`);
        console.log('Response:', response);
        setData(response);
      }
      else {
        const response = await get(`/healthCareProvider/healthCareProvider/id/${query?.get("id")}`);
        console.log('Response:', response);
        setData(response);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }


  const bookAppointment = async () => {
    console.log(fullName, age, gender, problem, selectedDate, selectedTime)

    let res;
    try {
      res = await post("/doctors/api/book", {
        ...bookingPayload, 
        bookedByName: fullName,
        notes: problem
      });
      console.log('Booking Response:', res);
      if(res){
        notification({
          type:"success",
          message:"Appointment booking request sent successfully"
        });
        setFullName("")
        setAge("")
        setGender("")
        setProblem("")
        setSelectedDate(days[0].fullDate)
        setSelectedTime("12:00 PM")

        setBookingPayload(null);
        getAvailableSlots();
      }
    } catch (error) {
      console.log('Error booking appointment:', error);
      setOpenConfirmationModal(true);
      notification({
        message: "Error booking appointment. Please try again.",
        type: "error"
      });
    }
  }


  const handleSlotClick = (slot) => {
    const payload = {
      slotId: slot.id,
      slot: {
        id: slot.id,
        employeeId: slot.employeeId,
        startTimeUtc: slot.startTimeUtc,
        endTimeUtc: slot.endTimeUtc,
        isBooked: true,
      },
      bookedByName: fullName,
      bookedByEmail: sessionStorage.getItem('email') || '',
      citizenId: Number(sessionStorage.getItem('userId') )|| '',
      notes: problem,
     
    };

    setBookingPayload(payload);
    console.log('Payload:', payload);
  };

  const getAvailableSlots = async () => {
    try {
      if (query?.get("cat") === 'doctor') {
        const response = await get(`/Doctors/api/slots/availableByDoctorId?doctorId=${query?.get("id")}`);
        console.log('Available Slots:', response);
        setAvailableSlots(response);
      }
      // else if (query?.get("cat") === 'caregiver') {
      //   const response = await get(`/appointment/availableSlots/caregiver/${query?.get("id")}`);
      //   console.log('Available Slots:', response);
      // }
    } catch (error) {
      console.error('Error fetching available slots:', error);
    }
  }



  useEffect(() => {
    getData();
    getAvailableSlots();
  }, [])

  const navigate = useNavigate();

  const createAppointment = async () => {
    console.log(fullName, age, gender, problem, selectedDate, selectedTime)

    let res;

    if (query.get("cat") === "doctor") {
      res = await post("/appointment", {
        doctorEmployeeId: data?.id,
        appointDate: formatDate(selectedDate),
        appointTime: formatTime(selectedTime),
        healthCareProviderId: data?.healthCareProvider?.id,
        description: problem
      })
    }
    else if (query.get("cat") === "caregiver") {
      res = await post("/appointment", {
        appointDate: formatDate(selectedDate),
        appointTime: formatTime(selectedTime),
        healthCareProviderId: data?.id,
        description: problem
      })
    }
    else {
      console.log("Invalid category")
    }



    console.log(res)

    if (res?.status === "success") {
      notification({
        message: res?.message,
        type: "success"
      })

      navigate(`profile?cat=${query.get("cat")}&id=${query.get("id")}`)
    }
    else {
      notification({
        message: res?.message,
        type: "error"
      })
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ width: '80%', margin: 'auto', padding: 4 }}>
        <Button onClick={() => navigate(-1)} variant="text">← Book Appointment</Button>

        {/* Scrollable Date Picker */}
        <Box sx={{ display: 'flex', gap: 1.5, overflowX: 'auto', marginTop: 2, pb: 1 }}>
          {/* {days.map((dayObj) => (
            <Button
              key={dayObj.fullDate}
              variant={selectedDate === dayObj.fullDate ? "contained" : "outlined"}
              onClick={() => setSelectedDate(dayObj.fullDate)}
              sx={{
                minWidth: 80,
                flexShrink: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                py: 1,
              }}
            >
              <Typography variant="body2">{dayObj.date}</Typography>
              <Typography variant="caption">{dayObj.day}</Typography>
            </Button>
          ))} */}
        </Box>

        <Card sx={{ marginTop: 3 }}>
          <CardContent>
            {/* <Typography variant="h6" gutterBottom>
              Available Time
            </Typography>
            <Grid container spacing={2}>
              {times.map((time) => (
                <Grid item xs={4} sm={3} md={2} key={time}>
                  <Button
                    fullWidth
                    variant={selectedTime === time ? "contained" : "outlined"}
                    onClick={() => setSelectedTime(time)}
                  >
                    {time}
                  </Button>
                </Grid>
              ))}
            </Grid> */}

            <ScheduleViewer bookingPayload={bookingPayload} handleSlotClick={handleSlotClick} problem={problem} gender={gender} age={age} fullName={fullName} availableSlots={availableSlots} />

            <Box mt={4}>
              <Typography variant="h6" gutterBottom>
                Patient Details
              </Typography>

              <Box mt={2}>
                <TextField
                  label="Full Name"
                  fullWidth
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Box>

              <Box display="flex" gap={2} mt={2}>
                <FormControl fullWidth>
                  <InputLabel>Age Bracket</InputLabel>
                  <Select
                    value={age}
                    label="Age Bracket"
                    onChange={(e) => setAge(e.target.value)}
                  >
                    <MenuItem value="18 - 24">18 - 24</MenuItem>
                    <MenuItem value="25 - 30">25 - 30</MenuItem>
                    <MenuItem value="31 - 40">31 - 40</MenuItem>
                    <MenuItem value="41+">41+</MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel>Gender</InputLabel>
                  <Select
                    value={gender}
                    label="Gender"
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              <Box mt={2}>
                <TextField
                  label="Write your Problem"
                  fullWidth
                  multiline
                  rows={4}
                  value={problem}
                  onChange={(e) => setProblem(e.target.value)}
                />
              </Box>

              <Button disabled={availableSlots?.length < 1} onClick={handleNext} variant="contained" fullWidth sx={{ mt: 3 }}>
                Book Appointment
              </Button>
            </Box>
          </CardContent>
        </Card>
        <PaymentModal open={open} onClose={() => setOpen(false)} openBankModal={handleOpenBankModal} />
        {
          <BankPaymentModal
            open={modalOpen}
            onClose={handleCloseModal}
            amount={8000.00}
            userEmail={sessionStorage.getItem('email') || ''}
            paymentTitle="Complete Your Payment"
            openConfirmationModal={() => setOpenConfirmationModal(true)}
            onPay={() => { bookAppointment(); handleCloseModal() }}
            onCancelAppointment={handleCloseModal}
          />
        }
        {
          <PaymentConfirmationModal
            open={openConfirmationModal}
            onClose={handleCloseConfirmation}
            userName="Jessica"
            doctorName="Dr. Williams"
            onAddToCalendar={() => {
              setOpenConfirmationModal(false);
              setRatingOpen(true);
            }}
          // onDoAnotherTime={handleAnotherTimeAction}
          />
        }
        {
          <DoctorRatingForm appointmentId={40} doctorId={query?.get("id")} ratingOpen={ratingOpen} handleRatingOpen={handleRatingOpen} />
        }
      </Box>
    </ThemeProvider>
  );
}
